import React from 'react'
import { useTranslation } from 'react-i18next'
import { Separator, LayoutBand, Image, H3, H5, Paragraph } from '@fs/zion-ui'
import { cdnRoot } from '../../services/services'

export default function PrepareForSpirituallyTemple() {
  const [t] = useTranslation()

  return (
    <main>
      <LayoutBand maxWidth="xs">
        <Separator />
        <Image
          alt={t('temple.picture.alt.recommend', 'Image of a temple recommend')}
          src={`${cdnRoot}/connect/informational/temple_recommend.png`}
        />
        <Separator />
        <H3>{t('informational.temple.prepare2.heading', 'Spiritual Preparation')}</H3>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare2.intro',
            'Before going to the temple baptistry for the first time, it helps to understand a few things about the temple and then take some time to prepare spiritually. Here are a few topics that might be good to review with your child as you prepare together, along with a great activity and some additional resources at the end:'
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare2.step1', '1. Baptism is Essential')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare2.step1-details',
            'The Savior taught that baptism is required to return to our Heavenly Father after this life. He said that "except a man be born of water and of the Spirit, he cannot enter into the kingdom of God" (John 3:5). Jesus showed us the way by being baptized to "fulfil all righteousness" (Matthew 3:15). This meant He was obedient to the commandment to be baptized.'
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare2.step2', '2. God Loves All His Children')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare2.step2-details',
            'Every person is a child of God. He knows them, loves them, and wants them to return to Him someday (see Moses 1:39). Many people have the opportunity to accept the gospel and be baptized while they are alive. But what about those who die without being baptized or even knowing about Jesus? God has not forgotten them! He has provided a way for all of His children to return to Him after this life.'
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare2.step3', '3. We Serve God and His Children in the Temple')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare2.step3-details',
            'In the temple, we can perform baptisms and confirmations in behalf of our ancestors or others who have died without that opportunity. In other words, we can represent them and act in their place. Ordinances performed in behalf of others are called proxy ordinances. We believe that those who have died are aware of the ordinances and can choose whether or not to accept these gifts offered in love.'
          )}
        </Paragraph>
        <Separator />
        <H5>{t('informational.temple.prepare2.step4', '4. We Strive to Be Ready')}</H5>
        <Separator />
        <Paragraph>
          {t(
            'informational.temple.prepare2.step4-details',
            'The temple is the Lord’s house. He wants us to be ready in every way when we go so that we can feel the peace and blessings that come from serving in the temple. Part of getting ready involves visiting with the bishop or branch president. He asks us questions that help us focus on Jesus Christ and how we can be worthy through His Atonement.'
          )}
        </Paragraph>
        <Separator />
      </LayoutBand>
    </main>
  )
}
